export function isNull(obj) {
  return obj !== null && obj !== undefined; 
}